/** Erro típico de extensões do Chrome (não originado no app Angular). */
export function isExtensionMessageChannelError(reason: unknown): boolean {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : '';

  return /message channel closed|asynchronous response by returning true/i.test(
    message,
  );
}
